import React from 'react'
import clockIcon from '../clock-icon.svg'

export const ClockIcon = () => {
	return (
		<img src={clockIcon} alt="Clock" width="35px" />
	)
}
